import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts/Default";
import Text from "../components/typography/Text";
import Textarea from "../components/inputs/Textarea";
import Button from "../components/buttons/Button";
import Checkbox from "../components/checkboxes/Checkbox";
import fetchApi from "../fetchApi";
import useApi from "../hooks/useApi";
import NotFound from "../pages/404";

const WorkWithEntrepreneur = ({ location }) => {
  const [comment, setComment] = React.useState();
  const [sent, setSent] = React.useState(false);
  const { mission: defaultMission, user = {} } =
    location && location.state ? location.state : {};
  const [selectedMissions, selectMission] = React.useReducer(
    reducer,
    defaultMission ? [defaultMission.id] : []
  );
  const author = defaultMission ? defaultMission.author : user.id;
  const { data, loading } = useApi(`/users?id=${author}`);
  const { data: missions } = useApi(`/mission?author=${author}`);
  const openedMissions =
    missions && Array.isArray(missions)
      ? missions.filter(({ close }) => !close)
      : [];

  const send = async () => {
    const formData = new FormData();

    formData.append("comment", comment);
    formData.append("to", project.id);
    formData.append("missions", selectedMissions);

    const options = {
      method: "post",
      body: formData,
    };

    const result = await fetchApi("/mail/workwith", options, false);

    if (
      result &&
      (result.code === 200 ||
        result.message === "Could not instantiate mail function.")
    ) {
      setSent(true);
    }
  };
  if (!loading && (!data || data.length === 0)) return <NotFound />;
  if (loading) return null;
  const [project] = data;
  return (
    <Layout title={`Work with ${project.company}`}>
      <div className="pWorkWith">
        {!sent ? (
          <div className="pWorkWith_content">
            <h3>I want to work with {project.company}</h3>
            <Text>
              Provide a compelling paragraph on why you would like to work on
              this project. This will greatly increase your chance of being
              called for an interview by our team.
            </Text>
            <h4>Design project(s) I would like to work on</h4>
            <div className="pWorkWith_checkboxes">
              {openedMissions &&
                openedMissions.map(mission => (
                  <Checkbox
                    key={mission.id}
                    label={mission.title.rendered}
                    checked={selectedMissions.includes(mission.id)}
                    setValue={() => selectMission(mission.id)}
                  />
                ))}
            </div>
            <Textarea label="Comment" value={comment} setValue={setComment} />
            <Button big onClick={send}>
              Send my request
            </Button>
          </div>
        ) : (
          <div className="pWorkWith_content">
            <h3>Message sent. Thank you !</h3>
            <Link to={`/project/${project.slug}`}>
              Go back to {project.company} profile
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
};

const reducer = (state, missionId) =>
  state.includes(missionId)
    ? state.filter(id => missionId !== id)
    : [...state, missionId];
export default WorkWithEntrepreneur;
